import Lenis from "lenis";

export class WorldMapScroll {
	constructor(element, onActivity) {
		this.element = element;
		this.lenis = null;
		this.onActivity = onActivity;
	}

	setEnabled(enabled) {
		if (enabled === Boolean(this.lenis)) return;
		if (!enabled) {
			// Stop first so a queued native-scroll callback cannot restore Lenis classes.
			this.lenis.stop();
			this.lenis.destroy();
			this.lenis = null;
			delete this.element.dataset.lenisActive;
			return;
		}
		this.lenis = new Lenis({
			autoRaf: false,
			duration: 1.1,
			easing: (progress) => 1 - (1 - progress) ** 3,
			smoothWheel: true,
			wheelMultiplier: 0.3,
			syncTouch: false,
			anchors: false,
			virtualScroll: (data) => this.filterWheel(data),
		});
		this.lenis.on("virtual-scroll", this.onActivity);
		this.element.dataset.lenisActive = "true";
	}

	filterWheel(data) {
		if (data.event.ctrlKey || !data.event.type.includes("wheel")) return false;
		const bounds = this.element.getBoundingClientRect();
		const start = scrollY + bounds.top;
		const end = scrollY + bounds.bottom - innerHeight;
		const outside = bounds.top > 1 || bounds.bottom < innerHeight - 1;
		// WebKit can settle just below a fractional target; wait for easing, not exact rounding.
		const leaving = !this.moving && ((scrollY >= end - 1 && data.deltaY > 0)
			|| (scrollY <= start + 1 && data.deltaY < 0));
		if (outside || leaving) {
			// Release native scrolling without any remaining map inertia.
			if (this.moving) this.lenis.reset();
			return false;
		}
		const target = this.lenis.targetScroll;
		const delta = Math.max(-120, Math.min(120, data.deltaY));
		const destination = Math.max(start, scrollY - 160, Math.min(end, scrollY + 160, target + delta));
		data.deltaY = destination - target;
		if (Math.abs(data.deltaY) < 0.01) {
			// A queued target at the boundary must not leak a native wheel jump.
			if (data.event.cancelable) data.event.preventDefault();
			return false;
		}
		return true;
	}

	get moving() {
		return this.lenis?.isScrolling === "smooth";
	}

	tick(time) {
		this.lenis?.raf(time);
	}

	scrollTo(top) {
		if (!this.lenis) return false;
		this.lenis.scrollTo(top, { duration: 1 });
		this.onActivity();
		return true;
	}
}
